import {gql} from "@apollo/client"

export const CategoryFormFragment = gql`
    fragment CategoryForm on Category {
        id
        name
        displayName
        workTypes {
            items {
                workType {
                    id
                    name
                }
            }
        }
        contests {
            items {
                contest {
                    year
                }
            }
        }
    }
`

export const WorkTypeFormFragment = gql`
    fragment WorkTypeForm on WorkType {
        id
        name
        content
        description
        maxCount
        maxLengthMinutes
        categories {
            items {
                category {
                    id
                }
            }
        }
    }
`

export const ContestFormFragment = gql`
    fragment ContestForm on Contest {
        id
        year
        categories {
            items {
                category {
                    id
                }
            }
        }
    }
`

export const CategoriesFragment = gql`
    fragment Categories on Category {
        id
        name
        displayName
        description
        workTypes {
            items {
                workType {
                    id
                    name
                    content
                    description
                    maxCount
                    maxLengthMinutes
                }
            }
        }
        contests {
            items {
                contest {
                    year
                }
            }
        }
    }
`

export const WorkTypesFragment = gql`
    fragment WorkTypes on WorkType {
        id
        name
        content
        description
        maxCount
        maxLengthMinutes
        categories {
            items {
                category {
                    id
                    name
                }
            }
        }
    }
`

export const ContestsFragment = gql`
    fragment Contests on Contest {
        id
        year
        categories {
            items {
                category {
                    id
                    name
                }
            }
        }
    }
`


export const ExistingSubmission = gql`
    fragment ExistingSubmission on Submission {
        id
        workTypeId
        workType {
            name
            content
            description
            maxCount
            maxLengthMinutes
        }
        category {
            id
            name
            displayName
        }
        createdAt
        submissionItems {
            items {
                id
                url
                fileName
                sortKey
            }
        }
    }
`

export const SubmissionsFragment = gql`
    ${ExistingSubmission}
    fragment SubmissionsFragment on Contest {
        year
        id
        submissions {
            items {
                ...ExistingSubmission
            }
        }
    }
`

export const MySubmissionsFragment = gql`
 fragment MySubmissionsFragment on Submission {
        id
        contestId
        contest {
          year
        }
        workTypeId
        workType {
            id
            name
            content
            description
            maxCount
            maxLengthMinutes
        }
        category {
            id
            name
            displayName
            description
        }
        createdAt
        updatedAt
        submissionItems {
            items {
                id
                url
                fileName
                sortKey
                contentType
                metadata
            }
        }
        submitted {
          items {
            contestId
          }
        }
 }
`

export const ContestStoreFragment = gql`
fragment ContestStoreFragment on Contest {
    id
    year
    categories {
        items {
            category {
                id
                displayName
                description
                workTypes {
                    items {
                        workType {
                            id
                            name
                            content
                            description
                            maxCount
                            maxLengthMinutes
                        }
                    }
                }
            }
        }
    }
}
`
